/**
 * External dependencies.
 */
import Image from "next/image";
import classNames from "classnames";

/**
 * Internal dependencies.
 */
import { getStrapiMedia } from "utils";
import Link from "components/link/link";

interface QuickHelpProp {
  title?: string;
  horizontal?: boolean;
  items?: {
    Icon?: any;
    Title?: string;
    Content?: string;
    Link?: string;
    OpenInNewTab?: boolean;
    RelNoFollow?: boolean;
  }[];
}

const QuickHelp: React.FC<QuickHelpProp> = ({ items, title, horizontal }) => (
  <div
    className={classNames("quick-help", {
      "quick-help--horizontal": horizontal,
    })}
  >
    {title && <div className="quick-help__head">{title}</div>}
    <div className="quick-help__inner">
      {items &&
        items.map((item, index) => {
          if (item.Link) {
            return (
              <Link
                href={item.Link}
                className="quick-help__box"
                key={index}
                OpenInNewTab={item.OpenInNewTab}
                RelNoFollow={item.RelNoFollow}
              >
                <div className="quick-help__icon">
                  {item.Icon.data && (
                    <Image
                      alt=""
                      src={getStrapiMedia(item.Icon)}
                      width={40}
                      height={40}
                    />
                  )}
                </div>
                <div className="quick-help__title">{item.Title}</div>
                <div className="quick-help__content">{item.Content}</div>
              </Link>
            );
          } else {
            return (
              <div className="quick-help__box" key={index}>
                <div className="quick-help__icon">
                  {item.Icon && (
                    <Image
                      alt=""
                      src={getStrapiMedia(item.Icon)}
                      width={40}
                      height={40}
                    />
                  )}
                </div>
                <div className="quick-help__title">{item.Title}</div>
                <div className="quick-help__content">{item.Content}</div>
              </div>
            );
          }
        })}
    </div>
  </div>
);

export default QuickHelp;
